import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import React, { Component } from 'react';
import { all_information, loadingShow } from '../App';
import Message from '../utils/Message/Message';
import {
  addOrganization,
  deleteOrganization,
  editOrganization,
  getOrganization,
} from '../services/Settings/Organization';

interface IProps { }
interface IState {
  organizationData: Array<any>;
}

const CONNECTION_TYPES = ['SQL', 'ODBC'];
interface IPasswordEditorProps {
  value: string;
}
interface IPasswordEditorState {
  value: string;
  visible: boolean;
}

class PasswordEditor extends Component<IPasswordEditorProps, IPasswordEditorState> {
  constructor(props: IPasswordEditorProps) {
    super(props);
    this.state = {
      value: props.value ?? '',
      visible: false,
    };
  }

  public get value(): string {
    return this.state.value;
  }

  private onChange = (args: any) => {
    this.setState({ value: args.value });
  };

  private toggleVisibility = () => {
    this.setState((prev) => ({ visible: !prev.visible }));
  };

  render() {
  return (
    <div>
      <label style={{ display: 'block', fontSize: '16px', color: '#d1d5db',  fontWeight: '500', marginBottom: "-2px" }}>
        MSSQL Password
      </label>
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        <TextBoxComponent
          type={this.state.visible ? 'text' : 'password'}
          value={this.state.value}
          change={this.onChange}
          name="password"
          style={{ paddingRight: '28px' }}
        />
        <span
          className={this.state.visible ? 'e-icons e-eye-slash' : 'e-icons e-eye'}
          onClick={this.toggleVisibility}
          title={this.state.visible ? 'Hide password' : 'Show password'}
          style={{
            position: 'absolute',
            right: 8,
            cursor: 'pointer',
            fontSize: '14px',
            color: '#ababab',
            paddingTop: '2px',
          }}
        />
      </div>
    </div>
  );
}
}

interface IConnectionTypeEditorProps {
  value: string;
}

class ConnectionTypeEditor extends Component<IConnectionTypeEditorProps> {
  private ddlObj: DropDownListComponent | null = null;

  public get value(): string {
    return this.ddlObj ? (this.ddlObj.value as string) : this.props.value;
  }

  render() {
    return (
      <div>
        <label style={{ display: 'block', fontSize: '16px', color: '#d1d5db',  fontWeight: '500', marginBottom: "-2px" }}>
        Connection Type
      </label>
      <DropDownListComponent
        dataSource={CONNECTION_TYPES}
        value={this.props.value}
        name="connection_type"
        ref={(scope: DropDownListComponent) => (this.ddlObj = scope)}
      />
      </div>
    );
  }
}

export default class OrganizationGrid extends Component<IProps, IState> {
  private organizationGrid: GridComponent;
  private passwordObj: PasswordEditor | null = null;
  private connectionTypeObj: ConnectionTypeEditor | null = null;

  constructor(props: IProps) {
    super(props);
    this.state = {
      organizationData: [],
    };
    this.organizationGrid = new GridComponent(props);
  }

  public validationRule: Object = { required: true };

  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'Search',
  ];

  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    mode: 'Dialog',
    showDeleteConfirmDialog: true,
  };

  public FilterOptions: FilterSettingsModel = { type: 'Menu' };

  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };

  toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getOrganization();
    }
  }

  SaveOrganizationAdd(data: any) {
    const password = this.passwordObj ? this.passwordObj.value : data.password;
    const connectionType = this.connectionTypeObj
      ? this.connectionTypeObj.value
      : data.connection_type;

    const obj = {
      organization_code: data.organization_code,
      description: data.description,
      data_source: data.data_source,
      database_name: data.database_name,
      connection_type: connectionType,
      dsn: data.dsn || null,
      url: data.url || null,
      user_id: data.user_id,
      password,
      app: 'UWORK',
      created_by: all_information.user_id,
      creation_date: new Date(),
    };

    loadingShow(true, 'Adding');
    addOrganization(obj)
      .then(() => {
        Message.success('Success');
        loadingShow(false);
        this.getOrganization();
      })
      .catch(() => {
        loadingShow(false);
        Message.error('Error occurred');
      });
  }

  SaveOrganizationEdit(data: any) {
    const password = this.passwordObj ? this.passwordObj.value : data.password;
    const connectionType = this.connectionTypeObj
      ? this.connectionTypeObj.value
      : data.connection_type;

    const obj = {
      organization_id: Number(data.organization_id),
      organization_code: data.organization_code,
      description: data.description,
      data_source: data.data_source,
      database_name: data.database_name,
      connection_type: connectionType,
      url: data.url || null,
      dsn: data.dsn || null,
      user_id: data.user_id,
      password,
      last_updated_by: all_information.user_id,
    };

    loadingShow(true, 'Editing');
    editOrganization(obj)
      .then(() => {
        Message.success('Success');
        loadingShow(false);
        this.getOrganization();
      })
      .catch(() => {
        loadingShow(false);
        Message.error('Error occurred');
      });
  }

  deleteOrganizationRow = (rows: any) => {
    const obj = JSON.stringify({
      organization_id: rows[0].organization_id,
    });
    loadingShow(true, 'Deleting');
    deleteOrganization(obj)
      .then(() => {
        Message.success('Success');
        loadingShow(false);
        this.getOrganization();
      })
      .catch(() => {
        loadingShow(false);
        Message.error('Error occurred');
      });
  };

  actionBeginOrganization(args: any) {
    if (args.action === 'add' && args.requestType === 'save') {
      this.SaveOrganizationAdd(args.data);
    } else if (args.action === 'edit' && args.requestType === 'save') {
      this.SaveOrganizationEdit(args.data);
    } else if (args.requestType === 'delete') {
      this.deleteOrganizationRow(args.data);
    }

    if (args.requestType === 'save' || args.action === 'cancel') {
      this.passwordObj = null;
      this.connectionTypeObj = null;
    }
  }

  componentDidMount() {
    this.getOrganization();
  }

  getOrganization() {
    getOrganization()
      .then((response: any) => {
        console.log('organization response:', response.data);
        this.setState({ organizationData: response.data });
      })
      .catch((e) => {
        console.error('organization fetch error:', e);
      });
  }

  private passwordEditTemplate(args: any) {
    return (
      <PasswordEditor
        value={args.password}
        ref={(scope: PasswordEditor) => (this.passwordObj = scope)}
      />
    );
  }

  private connectionTypeEditTemplate(args: any) {
    return (
      <ConnectionTypeEditor
        value={args.connection_type}
        ref={(scope: ConnectionTypeEditor) => (this.connectionTypeObj = scope)}
      />
    );
  }

  actionCompleteOrganization(args: any) {
  if (args.requestType === 'beginEdit' || args.requestType === 'add') {
    const input = args.form?.querySelector('[name="organization_id"]') as HTMLElement | null;
    if (input) {
      const wrapper =
        (input.closest('.form-group') as HTMLElement) ||
        (input.closest('.e-float-input') as HTMLElement) ||
        input.parentElement;
      if (wrapper) {
        wrapper.style.display = 'none';
      }
    }
  }
}

  render() {
    return (
      <div>
        <GridComponent
          id="gridOrganization"
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.organizationData}
          height="87vh"
          ref={(theGrid: GridComponent) => (this.organizationGrid = theGrid)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          showColumnChooser
          toolbarClick={this.toolbarClick.bind(this)}
          actionBegin={this.actionBeginOrganization.bind(this)}
          actionComplete={this.actionCompleteOrganization.bind(this)}
          gridLines="Both"
        >
          <ColumnsDirective>
            <ColumnDirective
              field="organization_id"
              headerText="Organization ID"
              isPrimaryKey={true}
              visible={true}
              allowEditing={false}
              textAlign="Left"
            />
            <ColumnDirective
              field="organization_code"
              headerText="Organization Code"
              textAlign="Left"
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field="description"
              headerText="Description"
              textAlign="Left"
            />
            <ColumnDirective
              field="data_source"
              headerText="Data Source"
              textAlign="Left"
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field="database_name"
              headerText="Database Name"
              textAlign="Left"
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field="connection_type"
              headerText="Connection Type"
              textAlign="Left"
              validationRules={this.validationRule}
              editTemplate={this.connectionTypeEditTemplate.bind(this)}
            />
            <ColumnDirective
              field="dsn"
              headerText="DSN"
              textAlign="Left"
            />
            <ColumnDirective
              field="url"
              headerText="URL"
              textAlign="Left"
            />
            <ColumnDirective
              field="user_id"
              headerText="MSSQL Username"
              textAlign="Left"
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field="password"
              headerText="MSSQL Password"
              textAlign="Left"
              validationRules={this.validationRule}
              editTemplate={this.passwordEditTemplate.bind(this)}
              template={(data: any) => data.password ? "********" : ""}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ColumnMenu,
              Resize,
              Group,
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}